// HubSpot 配置（参考 zeitro.com-gmcc-new.html）
const HUBSPOT_FORM_URL =
    'https://api.hsforms.com/submissions/v3/integration/submit/8947143/ea936cc8-74c5-43ca-9c35-9bedae7e1792'
const HUBSPOT_OWNER_ASSIGN_LAMBDA_URL =
    'https://nld4wo6x6hkzmtn46w3tlxwqta0yjwgj.lambda-url.us-west-1.on.aws/'

function getHubspotUtk() {
    if (typeof document === 'undefined') return ''
    const match = document.cookie.match(/(?:^|; )hubspotutk=([^;]+)/)
    return match ? decodeURIComponent(match[1]) : ''
}

function getInitialReferrerZeitroCookie() {
    if (typeof document === 'undefined' || !document.cookie) return ''
    const match = document.cookie.match(/(?:^|; )initial_referrer_zeitro=([^;]+)/)
    return match ? decodeURIComponent(match[1]) : ''
}

function getEntryReferrer() {
    if (typeof window === 'undefined') return ''
    let ref = window.sessionStorage.getItem('los_entry_referrer') || ''
    if (!ref) ref = getInitialReferrerZeitroCookie()
    if (!ref && typeof document !== 'undefined') ref = document.referrer || ''
    return ref
}

/** 仅在上报 HubSpot 前：若 URL 无 utm_source，则根据「进入 LOS 时记录的 referrer」推断（仅影响本次上报，无副作用） */
function utmSourceMediumFromReferrer() {
    const ref = getEntryReferrer()
    if (!ref) return null
    try {
        const host = new URL(ref).hostname.toLowerCase()
        const isGoogle =
            host === 'google.com' ||
            host === 'www.google.com' ||
            host.endsWith('.google.com') ||
            host.includes('.google.com.')
        const isBing =
            host === 'bing.com' ||
            host === 'www.bing.com' ||
            host.endsWith('.bing.com') ||
            host.includes('.bing.com.')
        const isYahoo =
            host === 'yahoo.com' ||
            host === 'www.yahoo.com' ||
            host.endsWith('.yahoo.com') ||
            host.includes('.yahoo.com.') ||
            host.includes('search.yahoo.com')
        const isDuckDuckGo =
            host === 'duckduckgo.com' ||
            host === 'www.duckduckgo.com' ||
            host.endsWith('.duckduckgo.com') ||
            host.includes('.duckduckgo.com.')
        if (isGoogle) return { utm_source: 'google', utm_medium: 'SEO' }
        if (isBing) return { utm_source: 'bing', utm_medium: 'SEO' }
        if (isYahoo) return { utm_source: 'yahoo', utm_medium: 'SEO' }
        if (isDuckDuckGo) return { utm_source: 'duckduckgo', utm_medium: 'SEO' }
    } catch (e) {
        /* ignore */
    }
    return null
}

/**
 * 提交 HubSpot 表单；可选调用 Lambda 分配 HubSpot owner（自主注册为 true，Owner 代建账号为 false）。
 */
export async function sendSignupToHubSpot({
    email,
    firstName,
    lastName,
    company,
    leadSource,
    utmParams,
    assignOwner = true,
}) {
    let utm_source = utmParams?.utm_source || ''
    let utm_medium = utmParams?.utm_medium || ''
    if (!utm_source) {
        const ref = getEntryReferrer()
        const fromRef = utmSourceMediumFromReferrer()
        if (fromRef) {
            utm_source = fromRef.utm_source
            utm_medium = fromRef.utm_medium
        } else if (!ref) {
            utm_medium = 'Direct'
        }
    }
    const hubspotFields = [
        { name: 'firstname', value: firstName || '' },
        { name: 'lastname', value: lastName || '' },
        { name: 'email', value: email || '' },
        { name: 'company', value: company || '' },
        { name: 'lead_source', value: leadSource || 'Zeitro Sign Up' },
        { name: 'created_from_page', value: window.location.href || 'Zeitro LO Signup' },
        { name: 'utm_source', value: utm_source },
        { name: 'utm_medium', value: utm_medium },
        { name: 'utm_campaign', value: utmParams?.utm_campaign || '' },
        { name: 'utm_term', value: utmParams?.utm_term || '' },
        { name: 'utm_content', value: utmParams?.utm_content || '' },
    ]
    const hubspotSubmitData = {
        fields: hubspotFields,
        context: {
            // hutk: getHubspotUtk(),
            pageUri: window.location.href || 'Zeitro LO Signup',
            pageName: document.title || 'Zeitro Loan Officer Sign Up',
        },
    }
    try {
        const formRes = await fetch(HUBSPOT_FORM_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(hubspotSubmitData),
        })
        if (!formRes.ok) throw new Error(formRes.statusText)
        if (!assignOwner) return

        const isProduction =
            process.env.NODE_ENV === 'production' &&
            process.env.REACT_APP_ENV !== 'staging' &&
            process.env.REACT_APP_ENV !== 'development'
        const lambdaBody = { email }
        if (!isProduction) lambdaBody.ownerId = '88819382'
        const lambdaRes = await fetch(HUBSPOT_OWNER_ASSIGN_LAMBDA_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(lambdaBody),
        })
        if (!lambdaRes.ok) throw new Error(lambdaRes.statusText)
    } catch (err) {
        console.warn('HubSpot signup sync failed:', err)
    }
}
